import session from "./session";

export default {

  getAddons(params) {
    return session.get(`/pricing/addons/`, { params,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  getTariffs(params) {
    return session.get(`/pricing/tariffs/`, { params,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  getVoipSite(product_id) {
    return session.get(`/voip/sites/${product_id}/`);
  },

  getNumbers(product_id) {
    return session.get(`/voip/sites/${product_id}/numbers/`);
  },

  sendFaultApptEmail(product_id) {
    return session.post(`/telco/lines/${product_id}/actions/send-fault-appt-reminder/`);
  },

  updateTelcoProduct(product_id,data){
    return session.patch(`/telco/lines/${product_id}/`,JSON.stringify(data));
  },

  updateProduct(product_id,data) {
    return session.patch(`/products/${product_id}/`,JSON.stringify(data));
  },

  updateMainNumber(product_id,number) {
    return session.patch(`/voip/sites/${product_id}/`,JSON.stringify({pilot_number_id: number}));
  },

  updateSiteConfig(product_id, data) {
    return session.patch(`/voip/sites/${product_id}/configuration/`, JSON.stringify(data));
  },

  searchProducts(payload) {
    return session.get(`/search/voip/?querystring=${encodeURIComponent(payload)}`);
  }
}
